import { IPixelMapDay, YearItem } from "@interfaces/pixel-map-day.interface";
import calendarEasterEgg2022 from "@data/pixel-map/easter-eggs/2022-calendar";
import calendarEasterEgg2023 from "@data/pixel-map/easter-eggs/2023-calendar";
import calendarEasterEgg2024 from "@data/pixel-map/easter-eggs/2024-calendar";
import calendarEasterEgg2025 from "@data/pixel-map/easter-eggs/2025-calendar";

const CALENDAR_MONTHS = [
	{ name: "January", shortName: "Jan", days: 31 },
	{ name: "February", shortName: "Feb", days: 28 },
	{ name: "March", shortName: "Mar", days: 31 },
	{ name: "April", shortName: "Apr", days: 30 },
	{ name: "May", shortName: "May", days: 31 },
	{ name: "June", shortName: "Jun", days: 30 },
	{ name: "July", shortName: "Jul", days: 31 },
	{ name: "August", shortName: "Aug", days: 31 },
	{ name: "September", shortName: "Sep", days: 30 },
	{ name: "October", shortName: "Oct", days: 31 },
	{ name: "November", shortName: "Nov", days: 30 },
	{ name: "December", shortName: "Dec", days: 31 },
];

const calendarEasterEggs: { [key: number]: IPixelMapDay } = {
	2022: calendarEasterEgg2022,
	2023: calendarEasterEgg2023,
	2024: calendarEasterEgg2024,
	2025: calendarEasterEgg2025
};

const YEAR_DATA: YearItem[] = [
	{ class: '', text: 2023 },
	{ class: '', text: 2024 },
	{ class: '', text: 2025 },
	{ class: '', text: 2026 },
];

const AVAILABLE_YEARS = [2023, 2024, 2025, 2026];

export {
	calendarEasterEggs,
	CALENDAR_MONTHS,
	YEAR_DATA,
	AVAILABLE_YEARS
};
